import React from 'react';
import DailyStatsTable from './DailyStatsTable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useAuth, UserType } from '../../context/AuthContext';


const Dashboard = () => {
    const { user } = useAuth();
     const today = format(new Date(), 'EEEE, d \'de\' MMMM \'de\' yyyy', { locale: es });
    return (
        <div className="container mt-4">
            {/* Encabezado con fecha */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="display-5">Sistema de Facilities</h1>
                        <span className="badge bg-secondary fs-6 p-3">
                            <i className="bi bi-calendar me-2"></i>
                            {today}
                        </span>
                    </div>
                    <hr className="my-4" />
                </div>
            </div>

            {/* Tarjeta de bienvenida con datos del usuario */}
            <div className="row mb-4">
                <div className="col-md-8 mx-auto">
                    <div className="card shadow-sm border-0">
                        <div className="card-body text-center">
                            <div className="mb-3">
                                <i className="bi bi-person-circle fs-1 text-primary"></i>
                            </div>
                            <h2 className="card-title h4 mb-3">
                                ¡Bienvenido, <strong>{user?.User.name}</strong>!
                            </h2>
                            <div className="row g-2 justify-content-center">
                                <div className="col-auto">
                                    <span className="badge bg-light text-dark p-2">
                                        <i className="bi bi-briefcase me-1"></i>
                                        Puesto: {user?.User.position}
                                    </span>
                                </div>
                                <div className="col-auto">
                                    <span className="badge bg-light text-dark p-2">
                                        <i className="bi bi-people me-1"></i>
                                        Role en Sistema: {user?.User.role}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenido según rol */}
            {/* {user?.User.role === "Administrativos" && ( */}
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-info text-center shadow-sm" role="alert">
                            <h4 className="alert-heading">
                                <i className="bi bi-building me-2"></i>
                                Grupo CIISA <sup>&reg;</sup>
                            </h4>
                            {/* <p className="mb-0">Tienes acceso administrativo al sistema.</p> */}
                        </div>
                    </div>
                </div>
            {/* )} */}

            {user?.User.role === "Supervisor de Taller" && (
                <>
                    {/* Tabla de estadísticas diarias */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm">
                                <div className="card-header bg-light">
                                    <h5 className="mb-0">
                                        <i className="bi bi-table me-2"></i>
                                        Estadísticas diarias
                                    </h5>
                                </div>
                                <div className="card-body">
                                    <DailyStatsTable />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Dashboard;
